<script lang="ts">
	import FormDivider from '$lib/components/Divider/FormDivider.svelte';
	import LoginForm from '$lib/components/Form/LoginForm.svelte';
	import SocialSignInForm from '$lib/components/Form/SocialSignInForm.svelte';
	import { classes } from '$lib/utils';
	import { getTranslate } from '@tolgee/svelte';

	const { t } = getTranslate();

	export let additionalClass = '';
</script>

<div class={classes(additionalClass, 'flex flex-col items-center justify-center')}>
	<div class="w-full flex flex-col max-w-[400px]">
		<LoginForm on:success />
		<FormDivider additionalClass="mt-8" />
		<SocialSignInForm on:socialSuccess />
	</div>
</div>
